export default {
  APP_NAME: "DOC_CLIENT",
  RESET_STATE: "RESET_STATE",
  RESET_STORE: "RESET_STORE",
  INIT_STORE: "INIT_STORE",

  PRIMARY_TYPE_BUTTON: "primary",
  SECONDARY_TYPE_BUTTON: "secondary",
  GHOST_TYPE_BUTTON: "ghost",
  DESTRUCTIVE_TYPE_BUTTON: "destructive",
  DISABLED_PRIMARY_TYPE_BUTTON: "disabled-primary",
  DISABLED_SECONDARY_TYPE_BUTTON: "disabled-secondary",

  ADMIN_ROLE: 1,
  ACCOUNT_ADMIN_ROLE: 2,
  FORM_ADMIN_ROLE: 3,
  USER_ROLE: 4,
  USER_SUPPORT_ROLE: 5,
  USER_ENTITY_LEGAL_ROLE: 6,
  USER_MEMBER_EDITOR_ROLE: 7,
  USER_MEMBER_ROLE: 8,
  USER_COMPANY_MEMBER_ROLE: 9,

  MARGIN_SCROLL_OF_LEFT: 0,
  WIDTH_OF_EDITOR: 360,

  SECTION_NAME_FOR_CLIENT_DEFAULT_GENERAL_FIELDS: "General",

  DEAL_DOCUMENTS_STATUS: {
    unPublished: "Unpublished",
    published: "Published",
    newVersion: "New Version in Progress",
    finalForm: "Final Form",
  },

  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",

  REGISTER: "REGISTER",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAIL: "REGISTER_FAIL",

  CONFIRM: "CONFIRM",
  CONFIRM_SUCCESS: "CONFIRM_SUCCESS",
  CONFIRM_FAIL: "CONFIRM_FAIL",

  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAIL: "FORGOT_PASSWORD_FAIL",

  LOGOUT: "LOGOUT",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAIL: "LOGOUT_FAIL",

  RESEND_CONFIRM: "RESEND_CONFIRM",
  RESEND_CONFIRM_SUCCESS: "RESEND_CONFIRM_SUCCESS",
  RESEND_CONFIRM_FAIL: "RESEND_CONFIRM_FAIL",

  CLIENT_CREATE: "CLIENT_CREATE_REQUEST",
  CLIENT_CREATE_SUCCESS: "CLIENT_CREATE_SUCCESS",
  CLIENT_CREATE_FAIL: "CLIENT_CREATE_FAIL",

  CLIENT_UPDATE: "CLIENT_UPDATE",
  CLIENT_UPDATE_SUCCESS: "CLIENT_UPDATE_SUCCESS",
  CLIENT_UPDATE_FAIL: "CLIENT_UPDATE_FAIL",

  GET_CLIENTS_LIST: "GET_CLIENTS_LIST_REQUEST",
  GET_CLIENTS_LIST_SUCCESS: "GET_CLIENTS_LIST_SUCCESS",
  GET_CLIENTS_LIST_FAIL: "GET_CLIENTS_LIST_FAIL",

  GET_CATEGORIES_LIST: "GET_CATEGORIES_LIST",
  GET_CATEGORIES_LIST_SUCCESS: "GET_CATEGORIES_LIST_SUCCESS",
  GET_CATEGORIES_LIST_FAIL: "GET_CATEGORIES_LIST_FAIL",

  CATEGORY_REMOVE: "CATEGORY_REMOVE",
  CATEGORY_REMOVE_SUCCESS: "CATEGORY_REMOVE_SUCCESS",
  CATEGORY_REMOVE_FAIL: "CATEGORY_REMOVE_FAIL",

  CATEGORY_CREATE: "CATEGORY_CREATE",
  CATEGORY_CREATE_SUCCESS: "CATEGORY_CREATE_SUCCESS",
  CATEGORY_CREATE_FAIL: "CATEGORY_CREATE_FAIL",

  CATEGORY_UPDATE: "CATEGORY_UPDATE",
  CATEGORY_UPDATE_SUCCESS: "CATEGORY_UPDATE_SUCCESS",
  CATEGORY_UPDATE_FAIL: "CATEGORY_UPDATE_FAIL",

  NOT_AUTHORIZED: "NOT_AUTHORIZED",
  SESSION_EXPIRED: "SESSION_EXPIRED",

  GET_DOCUMENT_STATS: "GET_DOCUMENT_STATS",
  GET_DOCUMENT_STATS_SUCCESS: "GET_DOCUMENT_STATS_SUCCESS",
  GET_DOCUMENT_STATS_FAIL: "GET_DOCUMENT_STATS_FAIL",

  GET_DOCUMENT_PAGE_PREVIEW: "GET_DOCUMENT_PAGE_PREVIEW",
  GET_DOCUMENT_PAGE_PREVIEW_SUCCESS: "GET_DOCUMENT_PAGE_PREVIEW_SUCCESS",
  GET_DOCUMENT_PAGE_PREVIEW_FAIL: "GET_DOCUMENT_PAGE_PREVIEW_FAIL",

  GET_DOCUMENT_META: "GET_DOCUMENT_META",
  GET_DOCUMENT_META_SUCCESS: "GET_DOCUMENT_META_SUCCESS",
  GET_DOCUMENT_META_FAIL: "GET_DOCUMENT_META_FAIL",

  GET_DOCUMENT_PARAGRAPHS: "GET_DOCUMENT_PARAGRAPHS",
  GET_DOCUMENT_PARAGRAPHS_SUCCESS: "GET_DOCUMENT_PARAGRAPHS_SUCCESS",
  GET_DOCUMENT_PARAGRAPHS_FAIL: "GET_DOCUMENT_PARAGRAPHS_FAIL",

  GET_DOCUMENT_DEFAULT_FORMAT: "GET_DOCUMENT_DEFAULT_FORMAT",
  GET_DOCUMENT_DEFAULT_FORMAT_SUCCESS: "GET_DOCUMENT_DEFAULT_FORMAT_SUCCESS",
  GET_DOCUMENT_DEFAULT_FORMAT_FAIL: "GET_DOCUMENT_DEFAULT_FORMAT_FAIL",

  DOCUMENT_DEFAULT_FORMAT_UPDATE: "DOCUMENT_DEFAULT_FORMAT_UPDATE",
  DOCUMENT_DEFAULT_FORMAT_UPDATE_SUCCESS:
    "DOCUMENT_DEFAULT_FORMAT_UPDATE_SUCCESS",
  DOCUMENT_DEFAULT_FORMAT_UPDATE_FAIL: "DOCUMENT_DEFAULT_FORMAT_UPDATE_FAIL",

  VARIABLE_CREATE: "VARIABLE_CREATE",
  VARIABLE_CREATE_SUCCESS: "VARIABLE_CREATE_SUCCESS",
  VARIABLE_CREATE_FAIL: "VARIABLE_CREATE_FAIL",

  COPY_VARIABLES_REQUEST: "COPY_VARIABLES_REQUEST",
  COPY_VARIABLES_SUCCESS: "COPY_VARIABLES_SUCCESS",
  COPY_VARIABLES_FAIL: "COPY_VARIABLES_FAIL",

  GET_VARIABLES_LIST: "GET_VARIABLES_LIST",
  GET_VARIABLES_LIST_SUCCESS: "GET_VARIABLES_LIST_SUCCESS",
  GET_VARIABLES_LIST_FAIL: "GET_VARIABLES_LIST_FAIL",

  SET_DEFAULT_VALUES_FOR_VARIABLES: "SET_DEFAULT_VALUES_FOR_VARIABLES",
  SET_DEFAULT_VALUES_FOR_VARIABLES_SUCCESS:
    "SET_DEFAULT_VALUES_FOR_VARIABLES_SUCCESS",
  SET_DEFAULT_VALUES_FOR_VARIABLES_FAIL:
    "SET_DEFAULT_VALUES_FOR_VARIABLES_FAIL",

  VARIABLE_REMOVE: "VARIABLE_REMOVE",
  VARIABLE_REMOVE_SUCCESS: "VARIABLE_REMOVE_SUCCESS",
  VARIABLE_REMOVE_FAIL: "VARIABLE_REMOVE_FAIL",

  VARIABLE_UPDATE: "VARIABLE_UPDATE",
  VARIABLE_UPDATE_SUCCESS: "VARIABLE_UPDATE_SUCCESS",
  VARIABLE_UPDATE_FAIL: "VARIABLE_UPDATE_FAIL",

  DOCUMENT_CREATE: "DOCUMENT_CREATE",
  DOCUMENT_CREATE_SUCCESS: "DOCUMENT_CREATE_SUCCESS",
  DOCUMENT_CREATE_FAIL: "DOCUMENT_CREATE_FAIL",

  GET_DOCUMENT: "GET_DOCUMENT",
  GET_DOCUMENT_SUCCESS: "GET_DOCUMENT_SUCCESS",
  GET_DOCUMENT_FAIL: "GET_DOCUMENT_FAIL",

  GET_DOCUMENT_UPDATE: "GET_DOCUMENT_UPDATE",
  GET_DOCUMENT_UPDATE_SUCCESS: "GET_DOCUMENT_UPDATE_SUCCESS",
  GET_DOCUMENT_UPDATE_FAIL: "GET_DOCUMENT_UPDATE_FAIL",

  GET_DOCUMENTS_LIST_REQUEST: "GET_DOCUMENTS_LIST_REQUEST",
  GET_DOCUMENTS_LIST_SUCCESS: "GET_DOCUMENTS_LIST_SUCCESS",
  GET_DOCUMENTS_LIST_FAIL: "GET_DOCUMENTS_LIST_FAIL",

  DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT",
  DOWNLOAD_DOCUMENT_SUCCESS: "DOWNLOAD_DOCUMENT_SUCCESS",
  DOWNLOAD_DOCUMENT_FAIL: "DOWNLOAD_DOCUMENT_FAIL",

  DOCUMENT_SET_FOCUS: "DOCUMENT_SET_FOCUS",
  DOCUMENT_SET_FOCUS_SUCCESS: "DOCUMENT_SET_FOCUS_SUCCESS",
  DOCUMENT_SET_FOCUS_FAIL: "DOCUMENT_SET_FOCUS_FAIL",

  DOCUMENT_REMOVE_FOCUS: "DOCUMENT_REMOVE_FOCUS",
  DOCUMENT_REMOVE_FOCUS_SUCCESS: "DOCUMENT_REMOVE_FOCUS_SUCCESS",
  DOCUMENT_REMOVE_FOCUS_FAIL: "DOCUMENT_REMOVE_FOCUS_FAIL",

  DOCUMENT_UPDATE: "DOCUMENT_UPDATE",
  DOCUMENT_UPDATE_FAIL: "DOCUMENT_UPDATE_FAIL",
  DOCUMENT_UPDATE_SUCCESS: "DOCUMENT_UPDATE_SUCCESS",

  DOCUMENT_REMOVE: "DOCUMENT_REMOVE",
  DOCUMENT_REMOVE_FAIL: "DOCUMENT_REMOVE_FAIL",
  DOCUMENT_REMOVE_SUCCESS: "DOCUMENT_REMOVE_SUCCESS",

  DOCUMENT_VERSION_CREATE: "DOCUMENT_VERSION_CREATE",
  DOCUMENT_VERSION_CREATE_FAIL: "DOCUMENT_VERSION_CREATE_FAIL",
  DOCUMENT_VERSION_CREATE_SUCCESS: "DOCUMENT_VERSION_CREATE_SUCCESS",

  NEW_DOCUMENT_VERSION_PUBLISH: "NEW_DOCUMENT_VERSION_PUBLISH",
  NEW_DOCUMENT_VERSION_PUBLISH_FAIL: "NEW_DOCUMENT_VERSION_PUBLISH_FAIL",
  NEW_DOCUMENT_VERSION_PUBLISH_SUCCESS: "NEW_DOCUMENT_VERSION_PUBLISH_SUCCESS",

  SEND_TO_EMAIL_DOCUMENT: "SEND_TO_EMAIL_DOCUMENT",
  SEND_TO_EMAIL_DOCUMENT_FAIL: "SEND_TO_EMAIL_DOCUMENT_FAIL",
  SEND_TO_EMAIL_DOCUMENT_SUCCESS: "SEND_TO_EMAIL_DOCUMENT_SUCCESS",

  VARIABLES_IMPORT: "VARIABLES_IMPORT",
  VARIABLES_IMPORT_FAIL: "VARIABLES_IMPORT_FAIL",
  VARIABLES_IMPORT_SUCCESS: "VARIABLES_IMPORT_SUCCESS",

  USER_CREATE: "USER_CREATE",
  USER_CREATE_FAIL: "USER_CREATE_FAIL",
  USER_CREATE_SUCCESS: "USER_CREATE_SUCCESS",

  USER_UPDATE: "USER_UPDATE",
  USER_UPDATE_FAIL: "USER_UPDATE_FAIL",
  USER_UPDATE_SUCCESS: "USER_UPDATE_SUCCESS",

  PROFILE_UPDATE_SUCCESS: "PROFILE_UPDATE_SUCCESS",

  CHANGE_EMAIL: "CHANGE_EMAIL",
  CHANGE_EMAIL_FAIL: "CHANGE_EMAIL_FAIL",
  CHANGE_EMAIL_SUCCESS: "CHANGE_EMAIL_SUCCESS",

  CANCEL_CHANGE_EMAIL: "CANCEL_CHANGE_EMAIL",
  CANCEL_CHANGE_EMAIL_FAIL: "CANCEL_CHANGE_EMAIL_FAIL",
  CANCEL_CHANGE_EMAIL_SUCCESS: "CANCEL_CHANGE_EMAIL_SUCCESS",

  SEND_CONFIRM_CHANGE_EMAIL: "SEND_CONFIRM_CHANGE_EMAIL",
  SEND_CONFIRM_CHANGE_EMAIL_FAIL: "SEND_CONFIRM_CHANGE_EMAIL_FAIL",
  SEND_CONFIRM_CHANGE_EMAIL_SUCCESS: "SEND_CONFIRM_CHANGE_EMAIL_SUCCESS",

  VERIFY_CHANGE_EMAIL: "VERIFY_CHANGE_EMAIL",
  VERIFY_CHANGE_EMAIL_FAIL: "VERIFY_CHANGE_EMAIL_FAIL",
  VERIFY_CHANGE_EMAIL_SUCCESS: "VERIFY_CHANGE_EMAIL_SUCCESS",

  GET_USERS_LIST: "GET_USERS_LIST",
  GET_USERS_LIST_FAIL: "GET_USERS_LIST_FAIL",
  GET_USERS_LIST_SUCCESS: "GET_USERS_LIST_SUCCESS",

  GET_USER: "GET_USER",
  GET_USER_FAIL: "GET_USER_FAIL",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",

  USER_UNSUBSCRIBE: "USER_UNSUBSCRIBE",
  USER_UNSUBSCRIBE_FAIL: "USER_UNSUBSCRIBE_FAIL",
  USER_UNSUBSCRIBE_SUCCESS: "USER_UNSUBSCRIBE_SUCCESS",

  USER_REVIVE: "USER_REVIVE",
  USER_REVIVE_FAIL: "USER_REVIVE_FAIL",
  USER_REVIVE_SUCCESS: "USER_REVIVE_SUCCESS",

  USER_REMOVE: "USER_REMOVE",
  USER_REMOVE_FAIL: "USER_REMOVE_FAIL",
  USER_REMOVE_SUCCESS: "USER_REMOVE_SUCCESS",

  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PASSWORD_FAIL: "CHANGE_PASSWORD_FAIL",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",

  GET_DOCUMENT_OWNERS_LIST: "GET_DOCUMENT_OWNERS_LIST",
  GET_DOCUMENT_OWNERS_LIST_FAIL: "GET_DOCUMENT_OWNERS_LIST_FAIL",
  GET_DOCUMENT_OWNERS_LIST_SUCCESS: "GET_DOCUMENT_OWNERS_LIST_SUCCESS",

  GET_DOCUMENT_CLIENTS_LIST: "GET_DOCUMENT_CLIENTS_LIST",
  GET_DOCUMENT_CLIENTS_LIST_FAIL: "GET_DOCUMENT_CLIENTS_LIST_FAIL",
  GET_DOCUMENT_CLIENTS_LIST_SUCCESS: "GET_DOCUMENT_CLIENTS_LIST_SUCCESS",

  DOCUMENT_EDITOR_INIT: "DOCUMENT_EDITOR_INIT",
  DOCUMENT_EDITOR_INIT_FAIL: "DOCUMENT_EDITOR_INIT_FAIL",
  DOCUMENT_EDITOR_INIT_SUCCESS: "DOCUMENT_EDITOR_INIT_SUCCESS",

  DOCUMENT_NAME_SECTIONS_UPDATE: "DOCUMENT_NAME_SECTIONS_UPDATE",
  DOCUMENT_NAME_SECTIONS_UPDATE_FAIL: "DOCUMENT_NAME_SECTIONS_UPDATE_FAIL",
  DOCUMENT_NAME_SECTIONS_UPDATE_SUCCESS:
    "DOCUMENT_NAME_SECTIONS_UPDATE_SUCCESS",

  GET_DOCUMENT_NAME_SECTIONS: "GET_DOCUMENT_NAME_SECTIONS",
  GET_DOCUMENT_NAME_SECTIONS_FAIL: "GET_DOCUMENT_NAME_SECTIONS_FAIL",
  GET_DOCUMENT_NAME_SECTIONS_SUCCESS: "GET_DOCUMENT_NAME_SECTIONS_SUCCESS",

  GET_DOCUMENT_PROGRESS_INFO: "GET_DOCUMENT_PROGRESS_INFO",
  GET_DOCUMENT_PROGRESS_INFO_FAIL: "GET_DOCUMENT_PROGRESS_INFO_FAIL",
  GET_DOCUMENT_PROGRESS_INFO_SUCCESS: "GET_DOCUMENT_PROGRESS_INFO_SUCCESS",

  GET_ACCOUNTS_LIST: "GET_ACCOUNTS_LIST",
  GET_ACCOUNTS_LIST_FAIL: "GET_ACCOUNTS_LIST_FAIL",
  GET_ACCOUNTS_LIST_SUCCESS: "GET_ACCOUNTS_LIST_SUCCESS",

  GET_ACCOUNT: "GET_ACCOUNT",
  GET_ACCOUNT_FAIL: "GET_ACCOUNT_FAIL",
  GET_ACCOUNT_SUCCESS: "GET_ACCOUNT_SUCCESS",

  UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
  UPDATE_ACCOUNT_FAIL: "UPDATE_ACCOUNT_FAIL",
  UPDATE_ACCOUNT_SUCCESS: "UPDATE_ACCOUNT_SUCCESS",

  CREATE_ACCOUNT: "CREATE_ACCOUNT",
  CREATE_ACCOUNT_FAIL: "CREATE_ACCOUNT_FAIL",
  CREATE_ACCOUNT_SUCCESS: "CREATE_ACCOUNT_SUCCESS",

  CREATE_MEMBER: "CREATE_MEMBER",
  CREATE_MEMBER_FAIL: "CREATE_MEMBER_FAIL",
  CREATE_MEMBER_SUCCESS: "CREATE_MEMBER_SUCCESS",

  HIDE_HINT: "HIDE_HINT",
  HIDE_HINT_FAIL: "HIDE_HINT_FAIL",
  HIDE_HINT_SUCCESS: "HIDE_HINT_SUCCESS",

  SET_HIJACK: "SET_HIJACK",
  SET_HIJACK_FAIL: "SET_HIJACK_FAIL",
  SET_HIJACK_SUCCESS: "SET_HIJACK_SUCCESS",

  REMOVE_ACCOUNT: "REMOVE_ACCOUNT",
  REMOVE_ACCOUNT_FAIL: "REMOVE_ACCOUNT_FAIL",
  REMOVE_ACCOUNT_SUCCESS: "REMOVE_ACCOUNT_SUCCESS",

  REMOVE_CLIENT: "REMOVE_CLIENT_REQUEST",
  REMOVE_CLIENT_FAIL: "REMOVE_CLIENT_FAIL",
  REMOVE_CLIENT_SUCCESS: "REMOVE_CLIENT_SUCCESS",

  SEND_INVITATION: "SEND_INVITATION",
  SEND_INVITATION_FAIL: "SEND_INVITATION_FAIL",
  SEND_INVITATION_SUCCESS: "SEND_INVITATION_SUCCESS",

  UPDATE_CONDITION: "UPDATE_CONDITION",
  UPDATE_CONDITION_FAIL: "UPDATE_CONDITION_FAIL",
  UPDATE_CONDITION_SUCCESS: "UPDATE_CONDITION_SUCCESS",

  REMOVE_CONDITION: "REMOVE_CONDITION",
  REMOVE_CONDITION_FAIL: "REMOVE_CONDITION_FAIL",
  REMOVE_CONDITION_SUCCESS: "REMOVE_CONDITION_SUCCESS",

  GET_PROGRESS_INFO: "GET_PROGRESS_INFO",
  GET_PROGRESS_INFO_FAIL: "GET_PROGRESS_INFO_FAIL",
  GET_PROGRESS_INFO_SUCCESS: "GET_PROGRESS_INFO_SUCCESS",

  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
  REMOVE_NOTIFICATION_FAIL: "REMOVE_NOTIFICATION_FAIL",
  REMOVE_NOTIFICATION_SUCCESS: "REMOVE_NOTIFICATION_SUCCESS",

  GET_FIELDS: "GET_FIELDS",
  GET_FIELDS_SUCCESS: "GET_FIELDS_SUCCESS",
  GET_FIELDS_FAIL: "GET_FIELDS_FAIL",

  CREATE_FIELD: "CREATE_FIELD",
  CREATE_FIELD_FAIL: "CREATE_FIELD_FAIL",
  CREATE_FIELD_SUCCESS: "CREATE_FIELD_SUCCESS",

  UPDATE_FIELD: "UPDATE_FIELD",
  UPDATE_FIELD_FAIL: "UPDATE_FIELD_FAIL",
  UPDATE_FIELD_SUCCESS: "UPDATE_FIELD_SUCCESS",

  REMOVE_FIELD: "REMOVE_FIELD",
  REMOVE_FIELD_FAIL: "REMOVE_FIELD_FAIL",
  REMOVE_FIELD_SUCCESS: "REMOVE_FIELD_SUCCESS",

  GET_SECTIONS: "GET_SECTIONS",
  GET_SECTIONS_SUCCESS: "GET_SECTIONS_SUCCESS",
  GET_SECTIONS_FAIL: "GET_SECTIONS_FAIL",

  CREATE_SECTION: "CREATE_SECTION",
  CREATE_SECTION_FAIL: "CREATE_SECTION_FAIL",
  CREATE_SECTION_SUCCESS: "CREATE_SECTION_SUCCESS",

  REMOVE_SECTION: "REMOVE_SECTION",
  REMOVE_SECTION_FAIL: "REMOVE_SECTION_FAIL",
  REMOVE_SECTION_SUCCESS: "REMOVE_SECTION_SUCCESS",

  UPDATE_SECTION: "UPDATE_SECTION",
  UPDATE_SECTION_FAIL: "UPDATE_SECTION_FAIL",
  UPDATE_SECTION_SUCCESS: "UPDATE_SECTION_SUCCESS",

  COPY_TEXT_TO_CLIPBOARD: "COPY_TEXT_TO_CLIPBOARD",
  COPY_TEXT_TO_CLIPBOARD_FAIL: "COPY_TEXT_TO_CLIPBOARD_FAIL",
  COPY_TEXT_TO_CLIPBOARD_SUCCESS: "COPY_TEXT_TO_CLIPBOARD_SUCCESS",

  IMPORTED_FIELD_VALUE: "IMPORTED_FIELD_VALUE",
  IMPORTED_FIELD_VALUE_SUCCESS: "IMPORTED_FIELD_VALUE_SUCCESS",
  IMPORTED_FIELD_VALUE_FAIL: "IMPORTED_FIELD_VALUE_FAIL",

  GET_CLIENTS_FIELDSET_REQUEST: "GET_CLIENTS_FIELDSET_REQUEST",
  GET_CLIENTS_FIELDSET_SUCCESS: "GET_CLIENTS_FIELDSET_SUCCESS",
  GET_CLIENTS_FIELDSET_FAIL: "GET_CLIENTS_FIELDSET_FAIL",

  UPDATE_CLIENTS_FIELDSET_REQUEST: "UPDATE_CLIENTS_FIELDSET_REQUEST",
  UPDATE_CLIENTS_FIELDSET_SUCCESS: "UPDATE_CLIENTS_FIELDSET_SUCCESS",
  UPDATE_CLIENTS_FIELDSET_FAIL: "UPDATE_CLIENTS_FIELDSET_FAIL",

  COPY_TEXT_STYLES: "COPY_TEXT_STYLES",
  COPY_TEXT_STYLES_SUCCESS: "COPY_TEXT_STYLES_SUCCESS",
  COPY_TEXT_STYLES_FAIL: "COPY_TEXT_STYLES_FAIL",

  PASTE_TEXT_STYLES: "PASTE_TEXT_STYLES",
  PASTE_TEXT_STYLES_SUCCESS: "PASTE_TEXT_STYLES_SUCCESS",
  PASTE_TEXT_STYLES_FAIL: "PASTE_TEXT_STYLES_FAIL",

  DEAL_CREATE: "DEAL_CREATE",
  DEAL_CREATE_SUCCESS: "DEAL_CREATE_SUCCESS",
  DEAL_CREATE_FAIL: "DEAL_CREATE_FAIL",

  GET_DEALS_LIST_REQUEST: "GET_DEALS_LIST_REQUEST",
  GET_DEALS_LIST_SUCCESS: "GET_DEALS_LIST_SUCCESS",
  GET_DEALS_LIST_FAIL: "GET_DEALS_LIST_FAIL",

  GET_DEAL_REQUEST: "GET_DEAL_REQUEST",
  GET_DEAL_SUCCESS: "GET_DEAL_SUCCESS",
  GET_DEAL_FAIL: "GET_DEAL_FAIL",

  DEAL_UPDATE: "DEAL_UPDATE",
  DEAL_UPDATE_SUCCESS: "DEAL_UPDATE_SUCCESS",
  DEAL_UPDATE_FAIL: "DEAL_UPDATE_FAIL",

  INVITE_MEMBER: "INVITE_MEMBER",
  INVITE_MEMBER_SUCCESS: "INVITE_MEMBER_SUCCESS",
  INVITE_MEMBER_FAIL: "INVITE_MEMBER_FAIL",

  WINDOWS: "Windows OS",
  MAC: "Macintosh",

  DEAL_COMPANY_UPDATE: "DEAL_COMPANY_UPDATE",
  DEAL_COMPANY_UPDATE_SUCCESS: "DEAL_COMPANY_UPDATE_SUCCESS",
  DEAL_COMPANY_UPDATE_FAIL: "DEAL_COMPANY_UPDATE_FAIL",

  UPDATE_INVESTOR_MEMBERS: "UPDATE_INVESTOR_MEMBERS",
  UPDATE_INVESTOR_MEMBERS_SUCCESS: "UPDATE_INVESTOR_MEMBERS_SUCCESS",
  UPDATE_INVESTOR_MEMBERS_FAIL: "UPDATE_INVESTOR_MEMBERS_FAIL",

  DEAL_COMPANY_MEMBER_UPDATE_REQUEST: "DEAL_COMPANY_MEMBER_UPDATE_REQUEST",
  DEAL_COMPANY_MEMBER_UPDATE_SUCCESS: "DEAL_COMPANY_MEMBER_UPDATE_SUCCESS",
  DEAL_COMPANY_MEMBER_UPDATE_FAIL: "DEAL_COMPANY_MEMBER_UPDATE_FAIL",

  REMOVE_INVITE_MEMBER: "REMOVE_INVITE_MEMBER",
  REMOVE_INVITE_MEMBER_SUCCESS: "REMOVE_INVITE_MEMBER_SUCCESS",
  REMOVE_INVITE_MEMBER_FAIL: "REMOVE_INVITE_MEMBER_FAIL",

  SEND_PERSON_INVITATION: "SEND_PERSON_INVITATION",
  SEND_PERSON_INVITATION_SUCCESS: "SEND_PERSON_INVITATION_SUCCESS",
  SEND_PERSON_INVITATION_FAIL: "SEND_PERSON_INVITATION_FAIL",

  GET_DOCUMENTS_SIGNERS: "GET_DOCUMENTS_SIGNERS",
  GET_DOCUMENTS_SIGNERS_SUCCESS: "GET_DOCUMENTS_SIGNERS_SUCCESS",
  GET_DOCUMENTS_SIGNERS_FAIL: "GET_DOCUMENTS_SIGNERS_FAIL",

  ADD_SIGNERS: "ADD_SIGNERS",
  ADD_SIGNERS_SUCCESS: "ADD_SIGNERS_SUCCESS",
  ADD_SIGNERS_FAIL: "ADD_SIGNERS_FAIL",

  REMOVE_SIGNERS: "REMOVE_SIGNERS",
  REMOVE_SIGNERS_SUCCESS: "REMOVE_SIGNERS_SUCCESS",
  REMOVE_SIGNERS_FAIL: "REMOVE_SIGNERS_FAIL",

  RESET_DEAL_ERRORS: "RESET_DEAL_ERRORS",

  SIGNATURE_REQUEST: "SIGNATURE_REQUEST",
  SIGNATURE_REQUEST_SUCCESS: "SIGNATURE_REQUEST_SUCCESS",
  SIGNATURE_REQUEST_FAIL: "SIGNATURE_REQUEST_FAIL",

  SIGNATURE_REMINDER_SUCCESS: "SIGNATURE_REMINDER_SUCCESS",

  GET_CURRENT_COMPANY: "GET_CURRENT_COMPANY",
  GET_CURRENT_COMPANY_SUCCESS: "GET_CURRENT_COMPANY_SUCCESS",
  GET_CURRENT_COMPANY_FAIL: "GET_CURRENT_COMPANY_FAIL",

  CREATE_SIGNERS: "CREATE_SIGNERS",
  CREATE_SIGNERS_SUCCESS: "CREATE_SIGNERS_SUCCESS",
  CREATE_SIGNERS_FAIL: "CREATE_SIGNERS_FAIL",

  UPDATE_SIGNERS: "UPDATE_SIGNERS",
  UPDATE_SIGNERS_SUCCESS: "UPDATE_SIGNERS_SUCCESS",
  UPDATE_SIGNERS_FAIL: "UPDATE_SIGNERS_FAIL",
};
